:host {
  --nested-margin-left: var(--stzh-timeline-nested-margin-left, 0px);
  --nested-margin-bottom: var(--stzh-timeline-nested-margin-bottom, 0px);

  // disable nested section paddings and margins
  --stzh-section-padding-top: 0px;
  --stzh-section-padding-bottom: 0px;
  --stzh-section-margin-top: 0px;
  --stzh-section-margin-bottom: 0px;

  ::slotted(*:not(:last-child)) {
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: (40px * 0.5);
      width: 2px;
      height: 100%;
      background-color: $colorGrey50;
    }
  }
}

.stzh-timeline {
  // offset margin of nested timelines
  --stzh-timeline-nested-margin-left: calc(var(--stzh-timeline-bullet-size) / -1);
  --stzh-timeline-nested-margin-bottom: calc(#{spaceCurveValue('regular')} / -1);

  margin-left: var(--nested-margin-left);
  margin-bottom: var(--nested-margin-bottom);

  @include mq($from: medium) {
    --stzh-timeline-nested-margin-bottom: calc(#{spaceCurveValue('regular', 'medium')} / -1);
  }

  @include mq($from: large) {
    --stzh-timeline-nested-margin-bottom: calc(#{spaceCurveValue('regular', 'large')} / -1);
  }
}
